import { render, staticRenderFns } from "./ChecklistForm1.vue?vue&type=template&id=6bbb8cfe"
import script from "./ChecklistForm1.vue?vue&type=script&lang=ts"
export * from "./ChecklistForm1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports